import { render, staticRenderFns } from "./ModalNuevaLiquidacion.vue?vue&type=template&id=e6f4fe54"
import script from "./ModalNuevaLiquidacion.vue?vue&type=script&lang=js"
export * from "./ModalNuevaLiquidacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports